import SharedIntegrated from "../shared-integrated";
import { loadUserTracker } from "../../core/user-tracker/index.js";

SharedIntegrated.setGlobal(window);
const { isAdLogin, _ENTER_YN, _IsMini } = window;

$(document).ready(async function () {
    LocalUtil.setLocal("ONLY_DEVICE_NM", "");
    LocalUtil.setLocal("ONLY_DEVICE_ID", "");
    Often.setCookie("FLOW_DUID", "");
    Often.setCookie("LAST_SUB_PATH", "");
    Often.setCookie("googleLoginYn", "");

    const queryParams = new URLSearchParams(location.search);
    if (queryParams.get("callback") === "extension") {
        await Internationalization.asyncInitSetting();
        const Integrated = await import('./integrated.js');
        Integrated.setGlobal();
        window.completeLoginCallback = () => {
            window.opener.postMessage({ action: "refreshWritingView" }, "*");
            window.close();
            return true;
        };
        CommonLogin.addClickEventOnSignIn();
        return;
    }

    const {Comm: {isElectronAvailable, getConfigs, init, isElectronApp}} = ElectronApi;


    try {
        if (isElectronAvailable() && getConfigs().b_fullMode) {$("header").remove()}
		if (isElectronAvailable() && !getConfigs().b_fullMode) $('.mjs-mini-back-btn').removeClass('d-none');
    } catch (e) {
        //pass
    }

    await Internationalization.asyncInitSetting();
    const Integrated = await import('./integrated.js');
    Integrated.setGlobal();

    init(false);
    loadUserTracker();
    TeamsHelper.removeTeams();
    if (_ENTER_YN != "Y") {
        ChannelTalk.drawButton()
    }

    if (isAdLogin && isElectronApp()) {
        AdLogin.checkAdIdAndConnect();
    } else {
        CommonLogin.goAutoLogin();
    }
    CommonLogin.setAutoCheck();
    InputtingTest.drawButton();

    if (_IsMini) {
        MiniLogin.addClickEvent();
    }

    CommonLogin.addClickEventOnSignIn();
    CommonLogin.checkSnsLoginAvailable();
    CommonLogin.checkUserIdBefore();
    // 로그인 페이지 url 파라미터로 input_user_id가 들어온 경우 아이디 input 세팅
    if (window.inputUserId) {
        CommonLogin.setUserIdIn$Input(window.inputUserId)
    }
    displayCustomPopup();
    $(document).scrollTop(0);
});

$(window).on('load', function () {

    setTimeout(function () {
        if (ServerChecker.isKsfc && !ElectronApi.Comm.isElectron()) {
            Often.logoutOnBrowserClose();
        }
        MonitorUtil.loadGtm();
    }, 1000);
})

function displayCustomPopup() {
    if (ServerChecker.isKsfc) {
        const currentDate = new Date();
        const expirationDate = new Date("2024-02-28T23:59:59");

        // 현재 날짜가 만료 날짜 이전인 경우에만 공사 팝업 띄우기
        if (currentDate < expirationDate) {
            const tempPopup = $(`<div id="ksfcPopup" class="position-abosolute-center">
                                     <img src="/enterprise/ksfc/img/underConstruction.png"/>
                                </div>
                           `).dblclick((event) => {
                $(event.target).closest("#ksfcPopup").remove();
           })
            $(document.body).append(tempPopup);
        }
    }
}
